import { withFormik } from "formik";
import { compose } from "@reduxjs/toolkit";
import { withAction } from "HOCs/withAction";
import { forgotPassword } from "services";
import mapPropsToValues from "./mapPropsToValues";
import validationSchema from "./validationSchema";
import handleSubmit from "./handleSubmit";
import ForgotPasswordForm from "./ForgotPasswordForm";

export const ForgotPasswordFormContainer = compose(
  withAction((props: any) => forgotPassword(props)),
  withFormik({
    mapPropsToValues,
    validationSchema,
    handleSubmit,
  })
)(ForgotPasswordForm);

export default ForgotPasswordFormContainer;
